import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { useThemeEffect } from '@/features/settings/theme'

export function Layout() {
  useThemeEffect()

  return (
    <div className="flex h-dvh min-h-0 w-full min-w-0 flex-col overflow-hidden bg-background">
      {/* Header spans full width at the top */}
      <Header />

      {/* Below header: sidebar and main content side by side */}
      <div className="flex min-h-0 min-w-0 flex-1 overflow-hidden">
        <Sidebar />
        <main className="min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto bg-background p-4 pl-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}